import styled from "styled-components";

export const Container = styled.div`
	@media screen and (min-width: 0px) {
		div.regulation {
			margin-top: 1.5em;

			.regulation__list {
				padding: 0;
				list-style: none;

				li {
					line-height: 1.313em;
					margin-bottom: 1.5em;
					font-size: 1.125em;
					line-height: 1.556em;

					span {
						font-family: "PFSquareSansProBold", sans-serif;
						font-size: 1em;
					}

					strong,
					a {
						font-family: "PFSquareSansProBold", sans-serif;
						text-decoration: none;
						font-size: 1em;
					}

					ul {
						list-style: none;
						padding-top: 15px;
						padding-left: 10px;

						li {
							margin-bottom: 5px;
						}
					}
				}

				p {
					margin-top: 1em;
					margin-bottom: 1em;
				}
			}

			table {
				margin-bottom: 1.5em;
			}

			table,
			th,
			td {
				border: 1px solid black;
				border-collapse: collapse;
				padding: 10px;
			}
		}
	}

	@media screen and (min-width: 992px) {
		div.regulation {
			margin-top: 4em;
			margin-bottom: 8em;

			.regulation__list {
				li {
					strong,
					a {
						color: var(--primary-color);
					}
				}
			}
		}
	}
`;
